import React from "react";

const AppsMoreCard = ({ details, onClickHandler }) => {
    const {title, description, svg} = details;
    return <div className="more_cards_cutom_w col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6">
        <div className="card card-stretch more_cards border-0" onClick={onClickHandler}>
            {(title.includes('Pilot') || title.includes('TruSense') || title.includes('Reactions'))? <span className="new-tag">New</span> : null}
            <div className="card-body text-center">
                <div className="symbol symbol-circle symbol-lg-75">
                    <span className="more_svg_icon">
                        {svg}
                    </span>
                </div>
                <div className="more_cards_cont">
                    <h4>{title}</h4>
                    <div className="more_cards_des">
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default AppsMoreCard